export default "__VITE_ASSET__BIi_Omes__"